import { all } from "redux-saga/effects";
import userWatcher from "./user/sagas";
import applicationWatcher from "@flow/store/application/sagas";
import { favouritesWatcher } from "./favourites/sagas";

export default function* indexSagas() {
  yield all([applicationWatcher(), userWatcher(), favouritesWatcher()]);
}



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/index-sagas.ts